import useAppDispatch from './useAppDispatch'
import {
  openDialog as openDialogAction,
  closeDialog as closeDialogAction,
} from '../redux/slices/config'
import { CapSource, IDialogActionsProps } from '../interfaces/actions'

/** Every cap source that is a purchase ceiling rather than an inventory limit. */
const CEILING_CAP_SOURCES: CapSource[] = ['maxQty', 'list', 'max']

export const useDialog = () => {
  const dispatch = useAppDispatch()
  const openDialog = ({
    icon,
    title,
    buttons,
    message,
    id,
    container,
    item,
    capSource,
    maxQtyTitle,
    maxQtyMessage,
    details,
    hidePrices,
    currency,
    currencyCode,
  }: IDialogActionsProps) => {
    // The counter reports which limit stopped it. Running out of stock and
    // reaching a purchase ceiling are different things to tell a customer, and
    // the stock wording is wrong for every ceiling — so when a caller supplies
    // ceiling-specific wording and a ceiling is what applied, prefer it.
    // Every other dialog omits these and is dispatched exactly as configured.
    //
    // All three non-stock sources qualify, not just `maxQty`: an `ItemList`
    // remaining-items limit and a configured `counter.max` are both ceilings, and
    // claiming "no stock left" for either is a false statement about inventory.
    // Matched against the known vocabulary rather than by excluding `'stock'`, so
    // an unresolved `{{this.capSource}}` template — which is not `'stock'` either —
    // keeps the wording it had instead of silently acquiring the ceiling copy.
    const isMaxQtyCap = CEILING_CAP_SOURCES.includes(capSource as CapSource)
    dispatch(
      openDialogAction({
        icon,
        title: (isMaxQtyCap && maxQtyTitle) || title,
        buttons,
        message: (isMaxQtyCap && maxQtyMessage) || message,
        id,
        container,
        details,
        hidePrices,
        currency,
        currencyCode,
      }),
    )
  }

  const closeDialog = ({ item, container, rejected }: IDialogActionsProps) => {
    dispatch(closeDialogAction({ container }))
  }

  return { openDialog, closeDialog }
}

export default useDialog
